import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'tpc-site',
    templateUrl: './site.component.html',
    styleUrls: ['./site.component.css']
})
export class SiteComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/site/site.component.ts